import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { API_URL } from './apiBase';

function showBlankScreen() {
  document.documentElement.style.background = '#fff';
  document.body.style.background = '#fff';
  document.body.style.margin = '0';
  const rootEl = document.getElementById('root');
  if (rootEl) {
    rootEl.replaceChildren();
  }
}

async function isBlockedVisitor() {
  const urls = [`${API_URL}/api/visitor/geo`];
  if (typeof window !== 'undefined' && API_URL !== window.location.origin) {
    urls.unshift('/api/visitor/geo');
  }
  for (const url of urls) {
    try {
      const res = await fetch(url);
      if (!res.ok) continue;
      const data = await res.json();
      if (data && data.blocked) return true;
      if (data && Object.prototype.hasOwnProperty.call(data, 'blocked')) return false;
    } catch (_) {
      // try next url
    }
  }
  return false;
}

async function bootstrap() {
  if (await isBlockedVisitor()) {
    showBlankScreen();
    return;
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

bootstrap();

